// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"492e3965","488":"984f96f6"}[chunkId] + ".chunk.js";
};